export const DEBUGLEVEL = {LOW: 1, MEDIUM: 2, HIGH: 3, VERBOSE: 4}
